import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { COLORS } from '../theme';

export default function AuthGuard({ children }) {
  const { user, claims, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: COLORS.bg,
      }}>
        <div style={{
          width: '36px',
          height: '36px',
          border: `3px solid ${COLORS.border}`,
          borderTopColor: COLORS.accent,
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (claims.role !== 'platform') {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: COLORS.bg,
        flexDirection: 'column',
        gap: '16px',
      }}>
        <div style={{
          fontSize: '48px',
          color: COLORS.danger,
        }}>⛔</div>
        <div style={{
          fontSize: '20px',
          fontWeight: '700',
          color: COLORS.textPrimary,
        }}>Not Authorized</div>
        <div style={{
          fontSize: '14px',
          color: COLORS.textSecondary,
          textAlign: 'center',
          maxWidth: '360px',
        }}>
          This portal is restricted to WorkrMatch staff.
        </div>
      </div>
    );
  }

  return children;
}
